// extracted by mini-css-extract-plugin
export default {"container":"LogUp_container__6zRjm","form":"LogUp_form__yUORs","title":"LogUp_title__hZzS8","navigateContainer":"LogUp_navigateContainer__75Bj3","subtitle":"LogUp_subtitle__Y06Vf"};